import PropTypes from 'prop-types';

export const projectShape = PropTypes.shape({
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  accountId: PropTypes.string.isRequired,
  accountName: PropTypes.string.isRequired,
  services: PropTypes.arrayOf(
    PropTypes.shape({ type: PropTypes.string.isRequired, category: PropTypes.string.isRequired })
  ).isRequired,
  containers: PropTypes.arrayOf(
    PropTypes.shape({ type: PropTypes.string.isRequired, id: PropTypes.string.isRequired })
  ).isRequired,
  imageUrl: PropTypes.string
});

export const accountShape = PropTypes.shape({
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  projectCount: PropTypes.number,
  imageUrl: PropTypes.string,
  idleTimeout: PropTypes.shape({ enabled: PropTypes.bool, duration: PropTypes.number })
});

export const currentUserShape = PropTypes.shape({
  id: PropTypes.string.isRequired,
  analyticsId: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  profileImg50: PropTypes.string
});

export default {
  projectShape,
  accountShape,
  currentUserShape
};
